import React, { useState } from "react";

import operationsImg from "../../assets/ai-development-company.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot } from "react-icons/fa";
import { TbSettingsCog } from "react-icons/tb"; // ✅ CORRECT ICON

const styles = `
  .op-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .op-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .op-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .op-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .op-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .op-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .op-header-badge .op-arrow {
    margin-left: auto;
    flex-shrink: 0;
  }

  .op-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .op-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .op-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .op-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .op-title-group h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .op-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .op-img-wrapper {
    flex: 1;
  }

  .op-img-wrapper img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .op-accordion {
    flex: 1.2;
  }

  .op-accordion-item {
    margin-bottom: 18px;
  }

  .op-accordion-header {
    background: linear-gradient(90deg, #2fb7a4 0%, #2f6f9f 60%, #2f4a7f 100%);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .op-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .op-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .op-header {
      height: auto;
      min-height: 90px;
    }

    .op-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .op-main {
      padding: 40px 40px;
      gap: 40px;
    }

    .op-title-group h2 {
      font-size: 26px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .op-header {
      flex-direction: column;
      height: auto;
    }

    .op-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .op-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .op-triangle-left,
    .op-triangle-right {
      width: 50px;
    }

    .op-title-group h2 {
      font-size: 22px;
    }

    .op-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .op-img-wrapper {
      width: 100%;
    }

    .op-img-wrapper img {
      max-width: 100%;
    }

    .op-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .op-header {
      flex-direction: column;
      height: auto;
    }

    .op-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .op-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .op-header-badge span:first-of-type {
      font-size: 12px;
    }

    .op-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .op-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .op-triangle-left,
    .op-triangle-right {
      width: 36px;
    }

    .op-title-group h2 {
      font-size: 18px;
    }

    .op-title-group svg {
      font-size: 24px !important;
    }

    .op-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .op-accordion-header {
      font-size: 13px;
      padding: 8px 14px;
    }

    .op-accordion-arrow {
      font-size: 18px;
    }

    .op-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .op-title-group h2 {
      font-size: 15px;
    }

    .op-accordion-header {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
`;

function OperationsPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    { title: "1.Process Mining", content: "Process mining can offer fastest period to insights about the as-is methods" },
    { title: "2.Predictive Maintenance", content: "AI Predictively maintain the robots and other machinery to minimize troubles to operations." },
    { title: "3.Manufacturing Analytics", content: "AI allows to analyse the manufacturing process from production to logistics and save time, lessen price, and rise efficiency." },
    { title: "4.Inventory & Supply Chain Optimization", content: "This reduces the stock, keeping spending, and maximize the inventory turnover shares." },
    { title: "5.Robotics", content: "AI can automate physical processes like manufacturing or logistics." },
    { title: "6.Collaborative Robot", content: "Flexible robots that learn by imitating human employees." },
    { title: "7.Cashierless Checkout", content: "AI allows stores to operate without cashiers." },
    { title: "8.Invoicing", content: "AI automates invoicing and reduces errors." }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* HEADER */}
      <div className="op-header">

        {/* LEFT */}
        <div
          className="op-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="op-header-overlay" />

          <div className="op-header-badge">
            <div className="op-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span className="op-arrow">›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="op-header-right">
          <div className="op-triangle-left" />
          <div className="op-triangle-right" />

          {/* ✅ FIXED ICON */}
          <div className="op-title-group">
            <TbSettingsCog style={{ fontSize: "32px", color: "#2fb7a4" }} />
            <h2>Operations</h2>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="op-main">
        <div className="op-img-wrapper">
          <img src={operationsImg} alt="" />
        </div>

        <div className="op-accordion">
          {data.map((item, i) => (
            <div key={i} className="op-accordion-item">
              <div
                className="op-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="op-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="op-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OperationsPage;
